(() => {
  if (customElements.get('recently-viewed-products')) {
    return;
  }

  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.productsHandle = localStorage.getItem('lastViewedProductId');
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.productsHandle) {
        this.classList.remove('hidden');

        this.productsHandle.split(',').forEach((handle) => {
          fetch(`/products/${handle}?view=card`)
            .then((response) => {
              if (response.ok) return response.text();
              return '';
            })
            .then((html) => {
              this.querySelector('[data-swiper-wrapper]').insertAdjacentHTML(
                'beforeend',
                html,
              );

              this.dispatchEvent(
                new CustomEvent('slider:init', { bubbles: true }),
              );
            });
        });
      }
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
})();
